import uniqBy from 'lodash.uniqby';
import { find as linkifyFind } from 'linkifyjs';

/**
 * Finds links to pages directly linked on the provided page.
 * @param {string} html Page HTML.
 * @param {string} url Page URL.
 * @returns {array} `[{ text: '/about/', href: 'https://example.com/about/' }]`
 */

const findPageLinks = (html, url) => {
  if (typeof html !== 'string' || typeof url !== 'string') return [];

  let pageUrl = null;
  let dom = null;

  try {
    pageUrl = new URL(url);
    dom = new DOMParser().parseFromString(html, 'text/html');
  } catch (err) {
    return [];
  }

  const links = Array.from(dom.querySelectorAll('a[href]'))
    .map((element) => {
      let elementURL = null;

      try {
        // `linkifyFind` creates a valid URL from links without protocol.

        const link =
          linkifyFind(element.attributes.href.nodeValue)[0]?.href ||
          element.attributes.href.nodeValue;

        elementURL = new URL(link, url);
      } catch (err) {
        //
      }

      return elementURL;
    })
    // Filter out URLs from the same origin but not the same href.
    .filter(
      (elementURL) =>
        elementURL &&
        `${elementURL.origin}${elementURL.pathname}`.startsWith(
          pageUrl.origin,
        ) &&
        `${elementURL.origin}${elementURL.pathname}` !== pageUrl.href &&
        `${elementURL.origin}${elementURL.pathname}` !==
          `${pageUrl.origin}${pageUrl.pathname}` &&
        !(
          elementURL.pathname.endsWith('.pdf') ||
          elementURL.pathname.endsWith('.png') ||
          elementURL.pathname.endsWith('.jpg') ||
          elementURL.pathname.endsWith('.jpeg') ||
          elementURL.pathname.endsWith('.gif')
        ),
    )
    .filter(
      (elementURL, index, arr) =>
        !(
          elementURL.href.endsWith('/') &&
          arr.some(({ href: matchHref }) => `${elementURL.href}/` === matchHref)
        ),
    )
    .map((elementURL) => ({
      text: elementURL.pathname,
      href: elementURL.href,
    }));

  return uniqBy(
    links.filter(({ href: c }) => c !== pageUrl.href),
    'text',
  );
};

export default findPageLinks;
